<template>
  <DynLang :by-key="label" />
</template>

<script lang="ts">
import { Spa } from '~/core/ts/entity/Spa'

export default defineNuxtComponent({
  props: {
    spaStatus: {
      type: String as PropType<Spa['status']>,
      required: true,
    },
  },
  setup(props) {
    const label = Spa.getStatusLabelTransKey(props.spaStatus)

    return {
      label,
    }
  }
})
</script>
